import { CollectionView } from '@glu/core';
import FlexDropdownTooltipItemView from './flexDropdownTooltipItemView';

export default CollectionView.extend({
  itemView: FlexDropdownTooltipItemView
});
